import { IPageBigHeader, IPageHeaderBlock } from '@features/cms/typescript';
import styles from '@features/cms/components/pages/PageHeaderBlock/PageHeaderBigBlock/PageHeaderBigBlock.styles';
import Heading from '@components/Heading/Heading';
import sanitizeHtml from '@utils/sanitizeHtml';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  data: IPageHeaderBlock<IPageBigHeader>;
  defaultBackground: string;
  isFirst: boolean;
};
const DEFAULT_IMG_W = 390;
const DEFAULT_IMG_H = 390;
const PageHeaderBigBlock = ({
  data,
  defaultBackground,
  isFirst
}: PropsType) => {
  const {
    backgroundColor,
    subHeader,
    image
  } = data.headerData;
  const subHeaderHtml = sanitizeHtml(subHeader);
  const imageDims = image && typeof image !== 'string' ? {
    width: Number(image.metadata?.width) || DEFAULT_IMG_W,
    height: Number(image.metadata?.height) || DEFAULT_IMG_H
  } : {
    width: DEFAULT_IMG_W,
    height: DEFAULT_IMG_H
  };
  return <header id={data.code} sx={styles.bigBlockHeader(backgroundColor || defaultBackground)} data-testid="page-header-big-block">
      <div sx={styles.bigBlockContent}>
        {image && <div sx={styles.imageContainer} data-testid="page-header-big-block-image-container">
            <ResponsiveImage image={typeof image === 'string' ? image : image.path} width={imageDims.width} height={imageDims.height} alt={typeof image !== 'string' ? image.metadata.alt || subHeader : subHeader} />
          </div>}
        <Heading h={isFirst ? 1 : 2} headingType={4} mobile>
          <span dangerouslySetInnerHTML={subHeaderHtml} />
        </Heading>
      </div>
    </header>;
};
export default PageHeaderBigBlock;